import type { SchemaField } from '@cli-types/core-engine/schema.js'

export function getTabNestedFields(tab: NonNullable<SchemaField['tabs']>[number]): SchemaField[] {
  return [
    ...(tab.fields ?? []),
    ...(tab.slot?.main?.fields ?? []),
    ...(tab.slot?.sidebar?.fields ?? [])
  ]
}
